module.exports = __webpack_public_path__ + "img/warning-24px.75760c20.svg";